/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    dialog: "dialog",
    panel: "panel",
    scrim: "scrim",
    container: "container",
    containerOpen: "container--open",
    containerEmbedded: "container--embedded",
    assistiveText: "assistive-text",
    openingActive: "dialog--opening-active",
};
export const SLOTS = {
    actionBar: "action-bar",
    alerts: "alerts",
    content: "content",
    contentTop: "content-top",
    contentBottom: "content-bottom",
    headerActionsStart: "header-actions-start",
    headerActionsEnd: "header-actions-end",
    headerMenuActions: "header-menu-actions",
    headerContent: "header-content",
    fab: "fab",
    footer: "footer",
    footerStart: "footer-start",
    footerEnd: "footer-end",
};
export const dialogPlacements = [
    "top",
    "top-start",
    "top-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "cover",
    "center",
];
export const dialogResizeStep = 25;
export const dialogDragStep = 25;
export const initialDragPosition = { x: 0, y: 0 };
export const initialResizePosition = { top: 0, right: 0, bottom: 0, left: 0 };
//# sourceMappingURL=resources.js.map
